import React from 'react';
import Styles from './RejectedReset.module.css';
import Page from 'Common/Layout/Page';
import ActionButton from 'Common/Buttons/ActionButton';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import PropTypes from 'prop-types';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import { Input } from '@material-ui/core';
import DataTable from 'Common/Table/DataTable';
import Section from 'Common/Layout/Section';

const View = ({
	submit,
	updateYear,
	setSearchId,
	data,
	onSelectionChange,
	resetContract,
	isSelected,
	selectedRow,
	searchYear
}) => {

	const schema = [
		{ field: "appointmentId", label: "Appointment ID"},
		{ field: "qualificationYear", label: "Qualification Year"},		
		{ field: "type", label: "Type" },
		{ field: "description", label: "Description" },
		{ field: "contract.releaseDate", label: "ReleaseDate" },
		{ field: "appointmentStatus", label: "Appointment Status" },
		{ field: "appointee.appointeeId", label: "Appointee Id" },
		{ field: "appointee.name", label: "Name" },
		{ field: "appointee.ni", label: "NI" },
	];

	let selected =false;

	const handleChange = (event) => {
		setSearchId(event.target.value);
	  }

	return (
		<Page title="Reset Rejected Contract">
            <Section>
                <h3 class="sr-only">Search</h3>
                <div className="container">
					<div className={Styles.formControl}>
						<YearSelector updateYear={updateYear} year={searchYear} numberOfPreviousYears={1} numberOfFutureYears={1} addLoopCheck={true} />
					</div>
					<div className={Styles.formControl}>
						<p>You can search using either the appointee id or appointment id</p>
						<label for="searchid-input" class="search-label">
							<span id="searchid-input-label" class="sr-only">
								Search this table
							</span>
							<Input type='text' onChange={handleChange} id="searchid-input" placeholder='Enter id' aria-labelledby="searchid-input-label"></Input>
						</label>
						<ActionButton text="Search" onClick={submit} />
					</div>
				</div>
			</Section>
            <Section>
                <h3 class="sr-only">Search Results</h3>
				<div className="container">
					<DataTable
						dataSource={data}
						keyField="appointmentId"
						schema={schema}
						pagination
						selected={selected}
						selection
						onSelectionChange={onSelectionChange}
					/>

					{isSelected && <p><strong>Selected appointment id :- {selectedRow.appointmentId}</strong></p>}

					{isSelected &&
							<ActionButton text="Reset" onClick={resetContract} />
					}

				</div>
            </Section>

			
		</Page>
	);
};

View.propTypes = {
	handleChange: PropTypes.func,
	data: PropTypes.array.isRequired,
	submit: PropTypes.func.isRequired,
	setSearchId: PropTypes.func.isRequired,
	updateYear: PropTypes.func.isRequired,
	onSelectionChange: PropTypes.func.isRequired,
	resetContract: PropTypes.func.isRequired,
	isSelected: PropTypes.bool.isRequired,
	selectedRow: PropTypes.any.isRequired,
	searchYear: PropTypes.string.isRequired
};
export default View;
